<template>
    <div class="mb-8">
        <page-headline title="test">
            <Link :href="route('auctions')">{{$t('pages.auctions.control.default.auction_controls')}}</Link>
            <span class="font-medium">/</span>
            {{ auction.id }}
        </page-headline>
        <div class="w-full mt-2">
            <div class="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md mx-0 md:mx-6 mt-2" role="alert">
                <div class="flex">
                    <div>
                        <p class="text-sm">{{$t('pages.auctions.control.default.auction_no_controls')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import PageHeadline from "@/Shared/PageHeadline";
import { Link } from '@inertiajs/vue2';
export default {

    metaInfo() {
        return {
            title: this.$t('pages.auctions.control.default.auction_controls') + ` ${this.auction.id}`
        }
    },

    name: "Default",

    layout: Layout,

    components: {
        PageHeadline,
        Link
    },

    props: {
        auction: {
            type: Object,
        }
    }
}
</script>
